import { GREY_1000, RED_700, media } from '@mnd-frontend/ui';
import styled from 'styled-components';

export const MenuItem = styled.li<{ $isActive?: boolean }>`
  margin: 0;
  padding: 0;
  color: ${props => (props.$isActive ? RED_700 : GREY_1000)};
  position: relative;
  ${media.lessThan('phablet')} {
    position: static;
  }
  > a {
    display: flex;
    align-items: center;
    color: inherit;
    height: 100%;
    text-decoration: none;
    &.nav-link-active {
      color: ${RED_700};
    }
  }
`;
